import { Button, MenuButton, type MenuButtonItem, Text } from "@assetwatch/ui";

export function BulkActionsToolbar({
  selectedCount,
  onClear,
  actions,
}: {
  selectedCount: number;
  onClear: () => void;
  actions: MenuButtonItem[];
}) {
  return (
    <div className="flex items-center gap-(--spacing-8) border-b border-outline-subtle bg-surface-container-low px-(--spacing-16) py-(--spacing-12)">
      <Text size="sm" weight="medium">
        {selectedCount} selected
      </Text>
      <Button onClick={onClear} size="sm" variant="ghost">
        Clear
      </Button>
      {actions.length > 0 ? (
        <MenuButton items={actions} label="Bulk actions" size="sm" />
      ) : null}
    </div>
  );
}
